import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

/**
 * @title Menu with icons
 */
@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css']
})
export class UserMenuComponent implements OnInit {
  name: any;

  constructor(private authSvc: AuthService) {}

  ngOnInit(): void {
       this.name = this.authSvc.getUserName();
  }

  logout() {
    this.authSvc.logout();
  }

}
